import { useEffect } from "react";
import { useDataContext } from "../../modules/Data/DataProvider";
import type { iModalState } from "../../modules/Data/types";

export interface UseUiMModalOverlayProps {
  modalState: iModalState;
  modalId: string;
  modalData: any;
  handleClose: () => void;
}

const useUiMModalOverlay = (): UseUiMModalOverlayProps => {
  const { modalState, updateModalState, updateIsQtvrOverlayVisible } = useDataContext();

  const disableBodyScroll = () => {
    document.body.style.overflow = "hidden";
    // Below are needed for iOS
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.width = "100%";
    document.body.style.position = "fixed";
  };

  const enableBodyScroll = () => {
    document.body.style.overflow = "unset";
    // Below are needed for iOS
    const scrollY = document.body.style.top;
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.position = "unset";
    globalThis.window.scrollTo(0, Number.parseInt(scrollY || "0", 10) * -1);
  };

  useEffect(() => {
    if (modalState.id) {
      disableBodyScroll();
    } else {
      enableBodyScroll();
    }
  }, [modalState.id]);

  const handleClose = () => {
    updateModalState({ id: "", data: null, isVisible: false });
    updateIsQtvrOverlayVisible(true);
  };

  return {
    modalState,
    modalId: modalState.id,
    modalData: modalState.params,
    handleClose,
  };
};

export default useUiMModalOverlay;
